import { useMemo } from 'react';

// hooks
import useAuth from './useAuth';
import useDynamicConfig from './useDynamicConfig';

const useUserRole = () => {
  const { activeRole } = useAuth();
  const { SYSTEM_ROLES, COMPANY_ROLES, PROPERTY_ROLES } = useDynamicConfig();

  return useMemo(
    () => ({
      hasSystemRole: !!activeRole && SYSTEM_ROLES.includes(activeRole.user_role_type_id),
      hasCompanyRole: !!activeRole && COMPANY_ROLES.includes(activeRole.user_role_type_id),
      hasPropertyRole: !!activeRole && PROPERTY_ROLES.includes(activeRole.user_role_type_id),
      activeRole
    }),
    [activeRole, COMPANY_ROLES, SYSTEM_ROLES, PROPERTY_ROLES]
  );
};

export default useUserRole;
